export function isSafariBrowser() {
  const { userAgent } = window.navigator;

  return /Safari/i.test(userAgent) && !/Android|Chrome|Chromium|CriOS|Edg|EdgiOS|OPR|OPiOS|FxiOS/i.test(userAgent);
}
